import React, { useMemo } from 'react';
import classNames from 'classnames';
const ModalFooter = ({ className, children, isBorder }) => {
    const renderContent = useMemo(() => {
        const classNameResult = classNames('ac-modal-footer', { 'ac-modal-footer-border': isBorder }, className);
        return React.createElement("div", { className: classNameResult }, children);
    }, [children, className, isBorder]);
    return React.createElement(React.Fragment, null, renderContent);
};
export { ModalFooter };
//# sourceMappingURL=ModalFooter.js.map